import React, { useState } from "react";
import { CardUi } from "../../../ui/CardUi";
import { Col, Divider, Form, Input, Row, Space, Switch, Tooltip } from "antd";
import { ButtonUi } from "../../../ui/ButtonUi";
import {
  InventarioConstants,
  TipoButtonConstants,
} from "../../../../types/typesConstants";
import { FormItemHiddenUi } from "../../../ui/FormItemHiddenUi";
import { AlmacenEmpleadoSelect } from "../../reusable/AlmacenEmpleadoSelect";
import { useSelector } from "react-redux";
import { TipoMovimientoSelect } from "../../reusable/TipoMovimientoSelect";
import { MovimientoSalidaFormTable } from "./MovimientoSalidaFormTable";
import { ItemDetalleModal } from "./modal/ItemDetalleModal";

export const MovimientoSalidaForm = ({ handleCloseForm }) => {
  const form = Form.useFormInstance();
  const { activeEmpleado } = useSelector((state) => state.auth);
  const [open, setOpen] = useState(false);
  const detallescomprobantemovimiento = Form.useWatch(
    "detallescomprobantemovimiento",
    form
  );
  const tieneobservacion = Form.useWatch("tieneobservacion", form);
  const almacenorigen = Form.useWatch("almacenorigen", form);
  const handleOpenModal = () => setOpen(true);
  const handleCloseModal = () => setOpen(false);
  return (
    <>
      <CardUi
        title="Movimiento de Salida"
        size="small"
        extra={[
          <Space wrap key="Opts">
            <Tooltip title="Cancelar" key="1">
              <ButtonUi
                typeUi={TipoButtonConstants.Cancelar}
                onClick={handleCloseForm}
              />
            </Tooltip>
            <Tooltip title="Guardar" key="2">
              <ButtonUi
                htmlType="submit"
                form="FormMovimientoSalida"
                typeUi={TipoButtonConstants.Guardar}
              />
            </Tooltip>
          </Space>,
        ]}
      >
        <FormItemHiddenUi name="id" />
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col xs={24} sm={24} md={24} lg={6} xl={6}>
            <Form.Item
              name="almacenorigen"
              label="Almacén"
              rules={[{ required: true, message: "Seleccione el almacén" }]}
            >
              <AlmacenEmpleadoSelect
                empleado={activeEmpleado?.id}
                name="almacenorigen"
                placeholder="Seleccione almacén"
                onChange={() => form.setFieldValue("inventario", null)}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} lg={6} xl={6}>
            <Form.Item
              name="tipomovimiento"
              label="Movimiento"
              rules={[{ required: true, message: "Seleccione el movimiento" }]}
            >
              <TipoMovimientoSelect
                tipooperacion={InventarioConstants.TipoOperacionSalida}
                name="tipomovimiento"
                placeholder="Seleccione movimiento"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col xs={24} sm={24} md={14} lg={14} xl={14}>
            <Space>
              <Form.Item name="tieneobservacion" valuePropName="checked">
                <Switch />
              </Form.Item>
              Añadir observación
            </Space>
          </Col>
        </Row>
        {tieneobservacion && (
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col xs={24} sm={24} md={24} lg={16} xl={16}>
              <Form.Item name="observacion" className="mb-1">
                <Input.TextArea
                  rows={2}
                  placeholder="Ingrese Observación"
                  maxLength={150}
                />
              </Form.Item>
            </Col>
          </Row>
        )}
        <Divider orientation="left" style={{ margin: "6px 0px" }}>
          <b>Detalle de items de inventario</b>
        </Divider>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col xs={24} sm={24} md={20} lg={16} xl={16}>
            <Form.List
              name="detallescomprobantemovimiento"
              rules={[
                ({ getFieldValue }) => ({
                  validator: async (_, value) => {
                    if (value < 1) {
                      return Promise.reject(
                        new Error(
                          "Ingrese al menos un item en el detalle de movimiento"
                        )
                      );
                    }
                    const notienelotes = getFieldValue(
                      "detallescomprobantemovimiento"
                    ).some((x) => x.manejalotes && !x.lotes);
                    const notieneseries = getFieldValue(
                      "detallescomprobantemovimiento"
                    ).some((x) => x.manejaseries && !x.series);
                    if (notienelotes) {
                      return Promise.reject(
                        new Error(
                          "Falta registrar los lotes para un item en el detalle de movimiento"
                        )
                      );
                    }
                    if (notieneseries) {
                      return Promise.reject(
                        new Error(
                          "Falta registrar los lotes para un item en el detalle de movimiento"
                        )
                      );
                    }
                    // if()
                  },
                }),
              ]}
            >
              {(fields, { add, remove }, { errors }) => (
                <>
                  <MovimientoSalidaFormTable
                    detallecomprobantemovimiento={detallescomprobantemovimiento}
                    handleDelete={remove}
                    OpenModal={handleOpenModal}
                    title={() => (
                      <ButtonUi
                        typeUi={TipoButtonConstants.AgregarTable}
                        onClick={() => handleOpenModal()}
                      />
                    )}
                  />
                  <Form.Item className="ui-errorlist">
                    <Form.ErrorList errors={errors} />
                  </Form.Item>
                </>
              )}
            </Form.List>
          </Col>
        </Row>
      </CardUi>
      <ItemDetalleModal
        open={open}
        almacenorigen={almacenorigen}
        onCancelModal={handleCloseModal}
      />
    </>
  );
};
